import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleGetShareByWithMeList } from 'store/notes/thunks';
import { handleGetWorksheetShareByWithMeList } from 'store/worksheet/thunks';
import { useCurrentUser } from 'store/users/selectors';
import ShareByMe from './shardByMe';
import ShareWithMe from './shareWithMe';
import PreviewNote from '../previewNote';
import SentryWrap from 'components/Sentry';

const ShareAction = ({ from, action, bookId, pageId, open, setOpen, onOpenNotes, seeAllNotes, type = 'note' }) => {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const [listData, setListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [previewNoteOpen, setPreviewNoteOpen] = useState({ open: false, data: null });

  const fetchData = async () => {
    setLoading(true);
    let result;
    if (type === 'worksheet') {
      result = await dispatch(
        handleGetWorksheetShareByWithMeList({
          bookId: bookId,
          page: pageId,
          currentUserId: currentUser.id,
        }),
      );
    } else {
      result = await dispatch(
        handleGetShareByWithMeList({
          bookId: bookId,
          page: pageId,
          currentUserId: currentUser.id,
        }),
      );
    }
    const sharedByMe = result?.sharedByMe;
    if (sharedByMe) {
      sharedByMe.filterAccessBy = sharedByMe?.share_list;
    }
    setListData({ sharedByMe: sharedByMe, sharedWithMe: result?.sharedWithMe });
    setLoading(false);
  };

  useEffect(() => {
    if (currentUser.id && action) {
      fetchData();
    }
  }, [action, bookId, pageId, currentUser.id]);

  const redirectPage = (data) => {
    setPreviewNoteOpen({ open: true, data: { ...data, from: from }, action: action });
    setOpen({});
  };

  return (
    <SentryWrap>
      <PreviewNote
        data={previewNoteOpen.data}
        open={previewNoteOpen.open}
        setOpen={(data) => setPreviewNoteOpen(data)}
        onOpenNotes={onOpenNotes}
        seeAllNotes={seeAllNotes}
        action={previewNoteOpen.action || action}
      />
      {action === 'shareByMe' && (
        <ShareByMe
          shareByMe={open}
          setShareByMe={setOpen}
          data={listData?.sharedByMe}
          redirectPage={redirectPage}
          loading={loading}
          from={from}
        />
      )}
      {action === 'shareWithMe' && (
        <ShareWithMe
          shareWithMe={open}
          setShareWithMe={setOpen}
          data={listData?.sharedWithMe}
          redirectPage={redirectPage}
          loading={loading}
          from={from}
        />
      )}
    </SentryWrap>
  );
};

export default ShareAction;
